import { render, staticRenderFns } from "./closureTemplatesForm.vue?vue&type=template&id=77338392"
import script from "./closureTemplatesForm.vue?vue&type=script&lang=js"
export * from "./closureTemplatesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports